import { Message } from 'element-ui';
import moment from 'moment';
import { mapState } from "vuex";

import commonActionHandle from "@/commonActionHandle";

// Constant 
import { CARD_INFORMATION } from "@/constant/constant";
import { API_CALL_STATUS, POPUP_ID, PAGINATION_STATUS } from "@/constant/baseConstant";
import { PRICE_PROPERTIES_NAME } from "@/constant/fixedRental";
import { ROUTE_URL } from "@/constant/route";
import EventBus from "@/event/EventBus";

// Component

export default {

    data() {
        return {
            cardInformation: CARD_INFORMATION,
            routeUrl: ROUTE_URL,
            popupId: POPUP_ID,
            paginationStatus: PAGINATION_STATUS,
            pricePropertiesName: PRICE_PROPERTIES_NAME,

            countError: 0,
            smoothTimeOut: 1000,
            errorCode: null,

            isShowInformation: true,
            isShowErrorInformation: false,

            msgPage: 'unknown',
            isLoading: false,
            loadingStatus: {
                color: '#9E9E9E',
                date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                text: 'unknow',
            },
        }
    },

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },

    methods: {
        matomoLog(Category, Action, Name, Value) {
            if(window.matomoEnabled){
                try {
                    let dataPush = ['trackEvent', Category, Action, Name];
                    if (Value) dataPush.push(Value);
                    if(window._paq) window._paq.push(dataPush);
                }
                catch (ex) { 
                    console.error(ex);
                }
            }
        },
        //#region Router url
        pushUrl(params) {
            this.$router.push(params);
        },
        //#endregion

        //#region Open url
        openUrl(url) {
            window.open(url, "_blank");
        },
        //#endregion

        showConfirm({ title, message, type }) {
            return this.$confirm(message, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'No. Thanks !',
                type: type ? type : 'warning'
            });
        },

        //#region Notification element
        notificationSuccess(title, message) {
            Message.success({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 3000,
                offset: 60,
                showClose: false,
                message: message,
            });
        },
        notificationInfo(title, message) {
            Message.info({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 1000,
                offset: 60,
                showClose: false,
                message: message,
            });
        },
        notificationWarning(title, message) {
            Message.warning({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 3000,
                offset: 60,
                showClose: false,
                message: message,
            });
        },
        notificationError(title, message) {
            Message.error({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 3000,
                offset: 60,
                showClose: false,
                message: message,
            });
        },
        // notificationSuccess(title, message) {
        //     Notification.success({
        //         title: title,
        //         dangerouslyUseHTMLString: true,
        //         duration: 3000,
        //         offset: 60,
        //         showClose: false,
        //         message: message,
        //         type: 'success'
        //     });
        // },
        // notificationInfo(title, message) {
        //     Notification.message({
        //         title: title,
        //         dangerouslyUseHTMLString: true,
        //         duration: 3000,
        //         offset: 60,
        //         showClose: false,
        //         message: message,
        //         type: 'warning'
        //     });
        // },
        // notificationWarning(title, message) {
        //     Notification.warning({
        //         title: title,
        //         dangerouslyUseHTMLString: true,
        //         duration: 3000,
        //         offset: 60,
        //         showClose: false,
        //         message: message,
        //         type: 'warning'
        //     });
        // },
        // notificationError(title, message) {
        //     Notification.error({
        //         title: title,
        //         dangerouslyUseHTMLString: true,
        //         duration: 3000,
        //         offset: 60,
        //         showClose: false,
        //         message: message,
        //         type: 'error'
        //     });
        // },
        //#endregion

        //#region Get information client
        getInformationClient() {
            let information = {
                sourceRequest: 'WEB',
                browserDetails: '',
                timeZone: '',
                resolutionDevice: '',
            };
            let navigatorList = {
                appCodeName: navigator.appCodeName,
                appName: navigator.appName,
                appVersion: navigator.appVersion,
                cookieEnabled: navigator.cookieEnabled,
                geolocation: navigator.geolocation,
                language: navigator.language,
                onLine: navigator.onLine,
                platform: navigator.platform,
                product: navigator.product,
                userAgent: navigator.userAgent
            };
            try {
                information.browserDetails = JSON.stringify(navigatorList);

                let offset = new Date().getTimezoneOffset(),
                    o = Math.abs(offset);
                let timeZoneBrowse = (offset < 0 ? "+" : "-") + Math.floor(o / 60);
                information.timeZone = timeZoneBrowse;

                information.resolutionDevice = `${window.screen.width}x${window.screen.height}`;
            } 
            catch (ex) { 
                console.error(ex);
            }
            return information;
        },
        //#endregion        

        //#region Display duration
        caclDurationDiffDate(startTime, endTime) {
            let totalDurations = moment.duration(moment(endTime).diff(moment(startTime))).asDays();
            return Number.parseFloat(Number.parseFloat(totalDurations).toFixed(2).toString()) + ' day';
        },
        //#endregion

        //#region Skip description
        skipDescription(value) {
            this.isShowInformation = value;
        },
        //#endregion

        //#region Open Pop-up
        openPopup(id) {
            $(`#${id}`).modal({ backdrop: "static" });
        },
        //#endregion

        //#region Close Pop-up
        closePopup(id) {
            $(`#${id}`).modal("hide");
            EventBus.$emit("closePopup", id);
        },
        //#endregion

        //#region Process Catch api request
        processCatchApiRequest(error, msg, tryCatchCount) {
            if (tryCatchCount) {
                this.countError += 1;
                if (error.name === 'Error') {
                    if (this.countError === tryCatchCount) {
                        this.showDialogExpired();
                    }
                }
            } else {
                if (error.name === 'Error') {
                    this.showDialogExpired();
                } else {
                    this.commonError(error, msg);
                }
                this.feedStatusLoading(API_CALL_STATUS.FAILED);
            }
        },
        //#endregion

        //#region Session has expired
        showDialogExpired() {
            if (this.$route.path !== '/login') {
                if(this.$root.isDialogExpiredShowing) return;
                this.$root.isDialogExpiredShowing = true;
                commonActionHandle.showCustomWarning(
                    'The current session has expired !',
                    'Please "Re-load page" or "re-login" to continue using the service.',
                    () => {
                        //this.$root.isDialogExpiredShowing = false;
                        setTimeout(() => {
                            location.href = "/login"
                        }, 500);
                    },
                    () => {
                        //this.$root.isDialogExpiredShowing = false;
                        this.countError = 0;
                        location.reload();
                    },
                    'Logout',
                    null,
                    false,
                );
            }
        },
        //#endregion

        //#region Common error
        commonError(error, msg) {
            console.log("commonError", error);
            this.$store.dispatch("common/showUnkownError", error, msg);
        },
        //#endregion

        //#region  Feed status
        feedStatusLoading(type, data) {
            switch (type) {
                case API_CALL_STATUS.LOADING:
                    this.loadingStatus = {
                        color: '#9E9E9E',
                        date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                        text: 'Loading data ...',
                    }
                    this.msgPage = 'Loading ...';
                    this.isLoading = true;
                    this.isShowErrorInformation = false;
                    break;
                case API_CALL_STATUS.SUCCESS:
                    setTimeout(() => {
                        this.loadingStatus = {
                            color: 'green',
                            date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                            text: 'The data has been updated successfully !',
                        }
                        if (data) {
                            if (data.length > 0) {
                                this.msgPage = 'Success';
                            } else {
                                this.msgPage = 'No data';
                            }
                        }
                        this.isLoading = false;
                    }, 500);
                    break;
                case API_CALL_STATUS.FAILED:
                    setTimeout(() => {
                        this.loadingStatus = {
                            color: 'red',
                            date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                            text: 'Updated data failed !',
                        }
                        this.msgPage = 'Failed !';
                        this.isLoading = false;
                        setTimeout(() => {
                        }, 500);
                    }, 500);
                    break;
                default:
                    this.loadingStatus = {
                        color: '#9E9E9E',
                        date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                        text: 'unknow',
                    }
                    this.msgPage = 'unknow';
                    this.isLoading = false;
                    break;
            }
        },
        //#endregion

        //#region Display duration 
        caclDuration(uptime) {
            let sec = uptime;
            let hrs = Math.floor(sec / 3600);
            let min = Math.floor((sec - (hrs * 3600)) / 60);
            let result = '';
            if (sec > 0) {
                if (sec < 1) {
                    sec = parseFloat(sec).toFixed(2);
                } else {
                    result += (hrs > 0 ? hrs + 'h' : '');
                    result += (min > 0 ? min + 'm' : '');
                }
            }
            else result = '-- : --';
            return result;
        },
        //#endregion

        // Count down
        countDown(date) {
            let result = '';

            // Set the date we're counting down to
            let countDownDate = new Date(date).getTime();

            let now = new Date();
            //let nowUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());

            // Find the distance between now and the count down date
            let distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (seconds > 0) {
                if (seconds < 1) {
                    seconds = parseFloat(seconds).toFixed(2);
                } else {
                    result += (days > 0 ? days + 'd ' : '');
                    result += (hours > 0 ? hours + 'h ' : '');
                    result += (minutes > 0 ? minutes + 'm ' : '');
                }
            }
            else result = "Can't calculate value";
            return result;
        },

        formatTime(value) {
            if (!value) value = new Date();
            var offset = new Date().getTimezoneOffset();
            var localVal = moment(value).add(-offset, 'minutes');
            return moment(localVal).calendar(null, {
                sameDay: '[Today] hh:mm A',
                lastDay: '[Yesterday] hh:mm A',
                lastWeek: 'MMM DD YYYY hh:mm A',
                sameElse: 'MMM DD YYYY hh:mm A',
            });
        }
    },
}